<template>
    <div id="contenedor-listado-contrato-deducciones">
        <v-list
          rounded>
          <v-list-item>
            <v-list-item-action></v-list-item-action>
            <v-list-item-content>
              <v-list-item-title
                class="font-weight-bold">
                Descripción
              </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action
              class="font-weight-bold">
              Porcentaje
            </v-list-item-action>
          </v-list-item>
          <v-divider
            class="my-1">
          </v-divider>
        <!-- Sin Seguridad -->
        <template
          v-for="deduccion in listadoDeducciones">
          <v-list-item
            v-if="mixValidaScopesActions(2)"
            :key="`deduccion-${deduccion.id}`"
            link
            :input-value="deduccion.registrada"
            active-class="selected primary--text"
            :disabled="enviandoFormulario"
            @click="toggleAgregarRemoverDeduccion(deduccion)"
            >
            <template
              v-slot:default>
              <v-list-item-action>
                <v-checkbox
                  :input-value="deduccion.registrada">
                </v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ deduccion.nombre }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <span
                  class="title">
                  {{ deduccion.porcentaje }}%
                </span>
              </v-list-item-action>
            </template>
          </v-list-item>
        </template>

        <!-- Con seguridad -->
        <template
          v-for="deduccion in listadoDeducciones">
          <v-list-item
            v-if="!mixValidaScopesActions(2)"
            :key="`deduccion-${deduccion.id}`"
            link
            :input-value="deduccion.registrada"
            active-class="selected primary--text"
            :disabled="enviandoFormulario"
            >
            <template
              v-slot:default>
              <v-list-item-action>
                <v-checkbox
                  v-if="mixValidaScopesActions(2)"
                  :input-value="deduccion.registrada">
                </v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ deduccion.nombre }}
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <span
                  class="title">
                  {{ deduccion.porcentaje }}%
                </span>
              </v-list-item-action>
            </template>
          </v-list-item>
        </template>

      </v-list>
    </div>
</template>

<script>
import DEDUCCIONES from '@/graphql/querys/administracion/catalogos/deducciones/deducciones.gql';
import CONTRATOS_DEDUCCIONES from '@/graphql/querys/administracion/contratos/deducciones/contratoDeducciones.gql';
import AGREGAR_CONTRATO_DEDUCCION from '@/graphql/mutations/administracion/contratos/contrato/deducciones/agregarContratoDeduccion.gql';
import REMOVER_CONTRATO_DEDUCCION from '@/graphql/mutations/administracion/contratos/contrato/deducciones/removerContratoDeduccion.gql';

export default {
  name: 'ListadoContratoDeducciones',
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    async toggleAgregarRemoverDeduccion(deduccion) {
      if (!deduccion.registrada) {
        await this.agregarDeduccion(deduccion.id);
      } else {
        await this.removerDeduccion(deduccion.registrada.id);
      }
    },
    async cargarContratoDeducciones() {
      await this.$apollo.queries.contratoDeducciones.refetch({
        idContrato: this.$route.params.idContrato,
      });
    },
    async agregarDeduccion(idDeduccion) {
      const payload = {
        idContrato: this.$route.params.idContrato,
        idDeduccion,
      };

      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: AGREGAR_CONTRATO_DEDUCCION,
          variables: payload,
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      await this.cargarContratoDeducciones();
      this.mixEsCargando();
    },
    async removerDeduccion(id) {
      const payload = {
        id,
      };

      this.mixEsCargando();
      this.enviandoFormulario = true;

      await this.$apollo
        .mutate({
          mutation: REMOVER_CONTRATO_DEDUCCION,
          variables: payload,
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });

      this.enviandoFormulario = false;
      await this.cargarContratoDeducciones();
      this.mixEsCargando();
    },
  },
  apollo: {
    deducciones: {
      query: DEDUCCIONES,
    },
    contratoDeducciones: {
      query: CONTRATOS_DEDUCCIONES,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {
    listadoDeducciones() {
      if (!this.deducciones || !this.contratoDeducciones) return [];
      return this.deducciones.map((deduccion) => ({
        ...deduccion,
        registrada: this.contratoDeducciones
          .find((contratoDeduccion) => contratoDeduccion.deduccion.id === deduccion.id) || null,
      }));
    },
  },
};
</script>

<style lang="scss">

</style>
